<template>
	<div class="basis-page-cls">
        <section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" />
        </section>
        <section class="basis-cls_table">
            <div class="header">
                <span class="title el-icon-document"> 数据列表</span>
                <div class="btns">
                    <el-button @click.stop="dialogFormVisible = true" type="primary" size="small" icon="el-icon-circle-plus-outline" class="right">新增客户</el-button>
                </div>
            </div>
            <div class="table">
				<table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="listQuery.pageNumber"
                    :limit.sync="listQuery.pageSize"
                    @pagination="getList" />
            </div>
        </section>

		<el-dialog title="添加客户" :modal-append-to-body="false" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="875px">
			<TouchIn v-if="dialogFormVisible" :subBrandList="subBrandList" :channelList="channelList" @closeDialogFormVisible="handleCloseDialogFormVisible" />
		</el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EnumMixin } from "utils/mixins";
import TouchIn from "./touchIn";
import { sift_query_list } from 'utils/sift';
export default {
	name: 'CustomerPageIndex',
	mixins: [EnumMixin],
	computed: {
        ...mapGetters([
			'userInfo',  
			'subBrandList',
			'channelList',
			'isShowPhone'
		])
    },
	components: { TouchIn },
	data() {
		return {
            column: [
				{
                    label: '序号',
                    width: 80,
                    render: (h, scope) => {
                        return <span>{((this.listQuery.pageNumber - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
                    }
                },
				{ label: '客户姓', prop: 'lastName', minWidth: 120 },
				{ label: '客户名', prop: 'firstName', minWidth: 120 },
				{
                    label: '电话号码',
                    minWidth: 150,
                    render: (h, scope) => {
                        return <span>{this.isShowPhone ? scope.row.phoneNumber : this.hiddenPhone(scope.row.phoneNumber)}</span>
                    }
                },
				{
                    label: '所属渠道',
                    minWidth: 100,
                    render: (h, scope) => {
                        return <span>{this.getChannelStatus(scope.row.channel)}</span>
                    }
                },
				{ label: '客户ID', prop: 'customerId', minWidth: 180 },
				{
                    label: '操作',
                    prop: 'cation',
                    align: 'center',
                    width: 80,
                    fixed: 'right',
                    render: (h, scope) => {
						return (
							<div>
								<el-button 
									onClick={() => this.handleView(scope.row)}
									type="text">
									详情
								</el-button>
							</div>
						)
                    }
                }
            ],
			filterHeader: [
				{ label: '电话号码', model: 'phoneNumber', type: 'input', default: '', placeholder: '请输入电话号码' },
				{ label: '邮箱', model: 'emailAddress', type: 'input', default: '', placeholder: '请输入邮箱' },
				{ label: '客户姓', model: 'lastName', type: 'input', default: '', placeholder: '请输入客户姓' },
				{ label: '客户名', model: 'firstName', type: 'input', default: '', placeholder: '请输入客户名' },
				{ label: '客户ID', model: 'customerId', type: 'input', default: '', placeholder: '请输入客户ID' },
				{ label: '子品牌', model: 'subBrand', type: 'select', default: '', list: [] },
				{ label: '所属渠道', model: 'channel', type: 'select', default: '', list: [] },
			],
			listQuery: {
				pageSize: 10,
                pageNumber: 1,
				brand: '',
				subBrand: '',
				channel: '',
				lastName: '',
				firstName: '',
				phoneNumber: '',
				customerId: '',
				emailAddress: ''
            },
			total: 0,
			list: [],
			dialogFormVisible: false
		}
    },
	watch: {
		$route: {
			handler(val){
				if(val?.query?.phone) {
					this.listQuery.phoneNumber = this.$route?.query?.phone;
					this.getList();
				} 
			},
			immediate: true,
			deep: true
		}
	},
	created() {
		this.getDetailInfo();
		this.filterHeader[5]['list'] = this.subBrandList;
		this.filterHeader[6]['list'] = this.channelList;
		if(localStorage.getItem('customer-page-list-query') && localStorage.getItem('customer-page-list-query') != 'undefined') {
			this.listQuery = JSON.parse(localStorage.getItem('customer-page-list-query'));
		}
		if(Object.keys(sift_query_list(this.listQuery)).length > 3) {
			this.getList();
		}
	},
	methods: {
		getList() {
			// if(this.$route?.query?.phone) {
			// 	this.listQuery.phoneNumber = this.$route?.query?.phone;
			// }
			this.listQuery.brand = this.userInfo.brandIdentify;
			localStorage.setItem('customer-page-list-query', JSON.stringify(this.listQuery));
			this.$api.apiPostCustomerList(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response.data;
				this.total = parseInt(response.total);
			});
		},
		hiddenPhone(phone) {
			if (!phone) return ''
			return phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
		},
		getDetailInfo() {
			this.$api.apiQueryTabColumn({brand: this.userInfo.brandIdentify}).then(response => {
				if(response.errcode != 0) return;
				const data = response.data;
				for(let i = 4; i < data.length; i++) {
					if(data[i]?.displayMode === 'input' && data[i]?.listQuery === 'Y') {
						this.filterHeader.push({
							label: data[i]?.columnName, model: data[i]?.columnKey, type: 'input', default: '', placeholder: `请输入${data[i]?.columnName}`
						});
					}
				}
			});
		},
		handleCloseDialogFormVisible(row) {
			this.dialogFormVisible = false;
			if(row) this.getList();
		},
		handleView(row) {
			this.$router.push({name: 'customerInfo', params: {id: row.customerId}});
		},
        filterSearch(query) {
			this.listQuery = Object.assign(this.listQuery, query);
			// if(Object.keys(sift_query_list(this.listQuery)).length > 3) {
			// 	this.getList();
			// } else {
			// 	this.$message.error('请选择查询条件');
			// }
			if(this.listQuery.phoneNumber || this.listQuery.customerId || this.listQuery.emailAddress || this.listQuery.lastName || this.listQuery.firstName) {
				this.getList();
			} else {
				this.$message.error('请选择查询条件');
			}
		}
    }
}
</script>